import React from "react";
import logo from "../../images/logo.jpeg";
import "./auth.css";

// Candle heights (%) / direction – purely decorative market backdrop
const CANDLES = [
  [38, 1], [52, 0], [30, 1], [64, 1], [44, 0], [72, 1], [50, 0], [36, 1],
  [58, 1], [46, 0], [80, 1], [62, 0], [40, 1], [68, 1], [54, 0], [76, 1],
];

export const AuthShell = ({ children, wide = false }) => (
  <div className="ic-auth">
    <div className="ic-auth-grid" />
    <div className="ic-auth-orb ic-orb-gold" />
    <div className="ic-auth-orb ic-orb-green" />
    <div className="ic-auth-candles" aria-hidden="true">
      {CANDLES.map(([h, up], i) => (
        <span
          key={i}
          className={up ? "up" : "down"}
          style={{ height: `${h}%`, animationDelay: `${(i % 8) * 0.35}s` }}
        />
      ))}
    </div>
    <img src={logo} alt="" className="ic-auth-watermark" aria-hidden="true" />
    <div className={`ic-auth-card ${wide ? "wide" : ""}`}>
      <img src={logo} alt="CryptoInterlink" className="ic-auth-logo" />
      {children}
    </div>
  </div>
);
